<div class="rounded-xl bg-white px-4 py-2 shadow-xl">
  <div class="my-4 flex w-full justify-between">
    <p class="primaryColor text-lg font-semibold">
      {{ isArabic() ? "الفاتورة" : "Invoice" }}
      <span>{{ length()! + "/" + itemIndex()! }}</span>
    </p>

    <div>
      <p
        [class]="getStatusClass(invoiceData()?.invoiceStatus?.titleEn)"
        class="text inline-flex max-w-[250px] min-w-[80px] items-center justify-center rounded-full px-2.5 py-2 text-center text-xs leading-[14px] font-[500] whitespace-nowrap">
        {{ isArabic() ? invoiceData()?.invoiceStatus?.titleAr : invoiceData()?.invoiceStatus?.titleEn }}
      </p>
    </div>
  </div>
  <div class="flex items-center gap-4">
    <div class="flex items-center gap-2">
      <div class="primaryColor">
        <app-invoice-icon />
      </div>
      <p>
        {{ isArabic() ? "رقم الفاتورة:" : "Invoice number:" }}
        <span class="mx-1">{{ invoiceData()?.id }}</span>
      </p>
    </div>
    <div class="flex items-center gap-2">
      <div class="primaryColor">
        <app-product-box-icon />
      </div>
      <p>
        {{ isArabic() ? "عدد الأصناف:" : "Product count:" }}
        <span class="mx-1">{{ invoiceData()?.productCount }}</span>
      </p>
    </div>
    <div class="flex items-center gap-2">
      <div class="primaryColor">
        <app-wallet-icon />
      </div>
      <p>
        {{ isArabic() ? "إجمالي الفاتورة:" : "Total Invoice:" }}
        <span class="mx-1">{{ invoiceData()?.totalStorePrice }}</span>
        <span i18n="@@egp">EGP</span>
      </p>
    </div>
  </div>

  <!-- <p>{{ invoiceData()?.orderId }}</p> -->

  <div class="mt-8 flex items-center justify-end gap-3">
    <app-submit-button>{{ isArabic() ? "الفاتورة" : "Invoice" }}</app-submit-button>
    <app-submit-button type="primary">{{ isArabic() ? "عرض كملف PDF" : "display as PDF file" }}</app-submit-button>
  </div>
</div>
